import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28 28",
  style: {"background-color":"#ffffff00"},
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M13 7h3v6h6v3h-6v6h-3v-6H7v-3h6zM3 15c0 6 5.1 11 12 11 6 0 11-5 11-11 0-6.9-5-12-11-12C8.1 3 3 8.1 3 15z",
      fill: "#55acba",
      stroke: "#fff",
      "stroke-width": "1"
    }, null, -1)
  ])))
}
export default { render: render }